import React from "react";
import PersonelPermissionGrid from "./components/PersonelPermissionGrid";
import Box from "@mui/material/Box";

function Manager() {
  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "auto",
      }}
    >
      <PersonelPermissionGrid />
    </Box>
  );
}

export default Manager;
